import { createSlice } from '@reduxjs/toolkit';
import type { RirekishoMotivation } from '@src/api/core/api-types';
import { createSimpleSliceReducers } from '../helpers/slice_helpers';

const initialState: RirekishoMotivation = {
  body: '',
};

const rirekishoMotivationSlice = createSlice({
  name: 'rirekishoMotivation',
  initialState,
  reducers: createSimpleSliceReducers<RirekishoMotivation>(),
});

export const { update: updateRirekishoMotivation } = rirekishoMotivationSlice.actions;

export default rirekishoMotivationSlice.reducer;
